export * from '@src/components/templates/occl/consent.tmpl.js';
export * from '@src/components/templates/occl/features.tmpl.js';
export * from '@src/components/templates/occl/footer.tmpl.js';
export * from '@src/components/templates/occl/group.tmpl.js';
export * from '@src/components/templates/occl/template.tmpl.js';
export * from '@src/components/templates/occl/viewTemplate.tmpl.js';
export * from '@src/components/templates/occl/mergeAccountsWrapper.tmpl.js';
export * from '@src/components/templates/occl/tooltip.tmpl.js';
export * from '@src/components/templates/occl/tefComsCustomerAttribute.tmpl.js';
export * from '@src/components/templates/occl/link.tmpl.js';
